function normalizePlanSummaryItem(item) {
  return {
    ...item,
    proposedBeads: Array.isArray(item?.proposedBeads) ? item.proposedBeads : [],
  }
}

export async function fetchPlanSummaryPage(requestJson, {
  limit = 50,
  cursor,
  status = 'pending_approval',
  jobId,
} = {}) {
  const params = new URLSearchParams({
    pagination: 'cursor',
    limit: String(limit),
  })

  if (cursor) {
    params.set('cursor', cursor)
  }
  if (status) {
    params.set('status', status)
  }
  if (jobId) {
    params.set('jobId', jobId)
  }

  const data = await requestJson(`/plans?${params}`)
  const rawItems = Array.isArray(data?.items)
    ? data.items
    : (Array.isArray(data?.plans) ? data.plans : [])

  return {
    items: rawItems.map(normalizePlanSummaryItem),
    limit: typeof data?.limit === 'number' && data.limit > 0 ? data.limit : limit,
    hasMore: data?.hasMore === true,
    nextCursor: typeof data?.nextCursor === 'string' ? data.nextCursor : null,
  }
}

export async function fetchAllPlanSummaryItems(requestJson, {
  limit = 100,
  maxPages = 10,
  status = 'pending_approval',
  jobId,
} = {}) {
  const items = []
  let cursor = undefined
  let pages = 0

  while (pages < maxPages) {
    pages += 1
    const page = await fetchPlanSummaryPage(requestJson, {
      limit,
      cursor,
      status,
      jobId,
    })

    items.push(...page.items)

    if (!page.hasMore || !page.nextCursor) {
      return items
    }

    cursor = page.nextCursor
  }

  throw new Error(`Plan summary pagination exceeded ${maxPages} pages`)
}

export async function fetchPlanCounts(requestJson) {
  const data = await requestJson('/plans/counts')
  const counts = data?.counts || {}
  return {
    totalPlans: Number(counts.totalPlans || 0),
    pendingApprovalPlans: Number(counts.pendingApprovalPlans || 0),
    approvedPlans: Number(counts.approvedPlans || 0),
    rejectedPlans: Number(counts.rejectedPlans || 0),
    modifiedPlans: Number(counts.modifiedPlans || 0),
    autoRejectedPlans: Number(counts.autoRejectedPlans || 0),
  }
}
